import { KbFolder } from '../types';

export const getFolderPath = (folders: KbFolder[], targetId: number | null): string[] => {
  if (targetId === null) return [];

  const find = (list: KbFolder[], path: string[]): string[] | null => {
    for (const folder of list) {
      const current = [...path, folder.name];
      if (folder.id === targetId) return current;
      const found = find(folder.children, current);
      if (found) return found;
    }
    return null;
  };

  return find(folders, []) || [];
};
